import ReactGA from "react-ga4";

// Inicializar Google Analytics
export function initGA() {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  // Solo inicializar en producción o si hay un ID configurado
  if (measurementId && import.meta.env.PROD) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        anonymizeIp: true, // Anonimizar IPs para privacidad
      },
      gtagOptions: {
        send_page_view: false, // Manualmente controlaremos las vistas de página
      },
    });
    console.log("Google Analytics inicializado");
  } else if (import.meta.env.DEV) {
    console.log("Google Analytics deshabilitado en modo desarrollo");
  } else {
    console.warn("Google Analytics: VITE_GA_MEASUREMENT_ID no configurado");
  }
}

// Registrar vista de página
export function logPageView(path, title) {
  if (import.meta.env.PROD && import.meta.env.VITE_GA_MEASUREMENT_ID) {
    ReactGA.send({
      hitType: "pageview",
      page: path,
      title: title || document.title,
    });
    console.log(`GA PageView: ${path}`);
  }
}

// Registrar evento personalizado
export function logEvent(category, action, label = null, value = null) {
  if (import.meta.env.PROD && import.meta.env.VITE_GA_MEASUREMENT_ID) {
    const eventParams = {
      category,
      action,
    };

    if (label) eventParams.label = label;
    if (value !== null) eventParams.value = value;

    ReactGA.event(eventParams);
    console.log(`GA Event: ${category} - ${action}`, label);
  }
}

// ========== Eventos específicos del catálogo ==========

// Evento: Ver producto
export function logProductView(productId, productName, category) {
  logEvent("Product", "View", productName, productId);

  // También enviar evento de ecommerce
  if (import.meta.env.PROD && import.meta.env.VITE_GA_MEASUREMENT_ID) {
    ReactGA.event("view_item", {
      currency: "BOB",
      value: 0,
      items: [
        {
          item_id: productId,
          item_name: productName,
          item_category: category,
        },
      ],
    });
  }
}

// Evento: Búsqueda
export function logSearch(searchTerm, resultCount) {
  logEvent("Search", "Query", searchTerm, resultCount);

  if (import.meta.env.PROD && import.meta.env.VITE_GA_MEASUREMENT_ID) {
    ReactGA.event("search", {
      search_term: searchTerm,
      result_count: resultCount,
    });
  }
}

// Evento: Aplicar filtro
export function logFilterApplied(filterType, filterValue) {
  logEvent("Filter", "Applied", `${filterType}: ${filterValue}`);
}

// Evento: Aplicar ordenamiento
export function logSortApplied(sortType) {
  logEvent("Sort", "Applied", sortType);
}

// Evento: Interacción con carrito
export function logCartInteraction(action, productName, productId) {
  logEvent("Cart", action, productName, productId);
}

// ========== Eventos de administrador ==========

// Evento: Agregar producto (Admin)
export function logAdminAddProduct(productName) {
  logEvent("Admin", "Add Product", productName);
}

// Evento: Editar producto (Admin)
export function logAdminEditProduct(productName, field) {
  logEvent("Admin", "Edit Product", `${productName} - ${field}`);
}

// Evento: Eliminar producto (Admin)
export function logAdminDeleteProduct(productName) {
  logEvent("Admin", "Delete Product", productName);
}

// Evento: Importación masiva CSV (Admin)
export function logAdminBulkImport(productCount) {
  logEvent("Admin", "Bulk Import", "CSV", productCount);
}

// Evento: Uso de filtros en admin
export function logAdminFilterUsed(filterType) {
  logEvent("Admin", "Filter Used", filterType);
}

// Evento: Búsqueda en admin
export function logAdminSearch(searchTerm) {
  logEvent("Admin", "Search", searchTerm);
}
